import { MotorVehicleIncidentConstants } from './motorVehicleIncident.constants'
import { IMotorVehicleIncidentState, IMotorVehicleIncidentAction } from './motorVehicleIncident.types'

export const initialMotorVehicleIncidentState: IMotorVehicleIncidentState = {
  numberOfVehiclesInvolved: '',
  airbagDeployed: [],
  vehicleImpactSite: null,
  locationOfPatientInVehicle: null,
  extricationRequired: null,
}

export function motorVehicleIncidentReducer(
  state: IMotorVehicleIncidentState = initialMotorVehicleIncidentState,
  action: IMotorVehicleIncidentAction
): IMotorVehicleIncidentState {
  switch (action.type) {
    case MotorVehicleIncidentConstants.SET_NUMBER_OF_VEHICLES_INVOLVED:
      return { ...state, numberOfVehiclesInvolved: action.numberOfVehiclesInvolved }
    case MotorVehicleIncidentConstants.SET_AIRBAG_DEPLOYED:
      return { ...state, airbagDeployed: action.airbagDeployed }
    case MotorVehicleIncidentConstants.SET_VEHICLE_IMPACT_SITE:
      return { ...state, vehicleImpactSite: action.vehicleImpactSite }
    case MotorVehicleIncidentConstants.SET_LOCATION_OF_PATIENT_IN_VEHICLE:
      return { ...state, locationOfPatientInVehicle: action.locationOfPatientInVehicle }
    case MotorVehicleIncidentConstants.SET_EXTRICATION_REQUIRED:
      return { ...state, extricationRequired: action.extricationRequired }
    case MotorVehicleIncidentConstants.RESET_MOTOR_VEHICLE_INCIDENT:
      return { ...initialMotorVehicleIncidentState }
    case MotorVehicleIncidentConstants.CLEAR_MOTOR_VEHICLE_INCIDENT:
      return { ...initialMotorVehicleIncidentState }
    case MotorVehicleIncidentConstants.SET_MOTOR_VEHICLE_INCIDENT:
      return { ...action.motorVehicleIncidentData }
    default:
      return state
  }
}
